module.exports = __webpack_public_path__ + "360c4f212e8a509dbf65b250ff730ae1.png";